// Due to the location of the shared folders, these imports automatically target
// the proper platform

const fileToUser = function(file){
  if( !file ) return file
  const userInfo = file.content.userInfo.tree
  const userData = file.content.userData && file.content.userData.tree
  // console.log('got user data')
  // console.log(userData)
  // console.log('got user info')
  const firstName = userInfo.firstName.content
  const lastName = userInfo.lastName.content
  const username = userInfo.username.content
  const role = userInfo.role.content

  let hash, _id, password, dropboxToken, dropboxId
  if( userData ){
    hash = userData.hash && userData.hash.content
    password = userData.password && userData.password.content
    _id = file._id //|| genId() maybe if we make sure there is no id in the request, it will create a new one
    dropboxToken = userData.dropboxToken && userData.dropboxToken.content
    dropboxId = userData.dropboxId && userData.dropboxId.content
  }

  let res = {}

  const all = {
    firstName,
    lastName,
    username,
    role,
    hash,
    password,
    _id,
    dropboxToken,
    dropboxId,
    version: file.version,
  }

  for( const key of Object.keys(all) ){
    if( all[key] ) res[key] = all[key]
  }


  return res
}

const userToFile = function(user){
  // console.log('translating this user to file', user )
  if( !user ) return user
  const {
    dropboxToken,
    dropboxId,
    firstName,
    lastName,
    username,
    password,
    hash,
    role,
    _id = genId()
  } = user
  const name = username
  const content = {
    'userInfo': {
      'tree': {
        'firstName': { content: firstName },
        'lastName': { content: lastName },
        'username': { content: username },
        'role': {content: role}
      }
    },
    'userData': {
      'tree': {
        '_parentId': { content: _id.toString() },
        'hash': { content: hash },
        'dropboxToken': { content: dropboxToken },
        'dropboxId': { content: dropboxId },
        'password': { content: password },
      }
    }
  }
  // console.log('Sending back content', content.userInfo.tree.firstName)
  const res = {content, name}
  // console.log('root keys', Object.keys(res))
  return res
}

const genId = (() =>
  // Good luck!
  // https://stackoverflow.com/a/37438675/1798148
  (m = Math, d = Date, h = 16, s = x => m.floor(x).toString(h)) => // eslint-disable-line
  s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h)))()

// turns windows path into js path
const jsPath = function(p){
  return p.replace(/\\/g, '/')
}

const promiseWrapper = function(fnToWrap){
  return new Promise(function(resolve, reject){
    let callback = (err, data)=>{
      if( err ) {
        reject(err)
      } else {
        resolve(data)
      }
    }
    fnToWrap(callback)
  })
}

// Constants
/*eslint-disable */
const jVoid = 'javascript:void(0)'

const clone = function(obj){
  if( !obj ) return obj
  return JSON.parse(JSON.stringify(obj))
}

// Finds an item in an array; maybe deprecate? only used by control manager
const findInIterable = function(test, array){
  for( let idx in array ) {
    if( test(array[idx]) ) {
      return parseInt(idx, 10)
    }
  }
  return -1
}

// Checks whether a thing is an array or not... kind of wonky, be suspicious of it
const isIterable = function(obj){
  return !!(obj && typeof obj === 'object' && (obj.length !== 'undefined' || Object.keys(obj).length))
}

// Timeout in promise form
const sleep = function(ms){
  return new Promise((resolve, reject) => {
    setTimeout(resolve, ms)
  })
}


let stringSimilarity = {
	compareTwoStrings,
	findBestMatch
}

function compareTwoStrings(first, second) {
	first = first.replace(/\s+/g, '')
	second = second.replace(/\s+/g, '')

	if (!first.length && !second.length) return 1            // if both are empty strings
	if (!first.length || !second.length) return 0            // if only one is empty string
	if (first === second) return 1       							       // identical
	if (first.length === 1 && second.length === 1) return 0  // both are 1-letter strings
	if (first.length < 2 || second.length < 2) return 0			 // if either is a 1-letter string

	let firstBigrams = new Map()
	for (let i = 0; i < first.length - 1; i++) {
		const bigram = first.substr(i, 2)
		const count = firstBigrams.has(bigram)
			? firstBigrams.get(bigram) + 1
			: 1;

		firstBigrams.set(bigram, count)
	}

	let intersectionSize = 0;
	for (let i = 0; i < second.length - 1; i++) {
		const bigram = second.substr(i, 2)
		const count = firstBigrams.has(bigram)
			? firstBigrams.get(bigram)
			: 0

		if (count > 0) {
			firstBigrams.set(bigram, count - 1)
			intersectionSize++
		}
	}

	return (2.0 * intersectionSize) / (first.length + second.length - 2)
}

function findBestMatch(mainString, targetStrings) {
	if (!areArgsValid(mainString, targetStrings)) throw new Error('Bad arguments: First argument should be a string, second should be an array of strings');

	const ratings = []
	let bestMatchIndex = 0

	for (let i = 0; i < targetStrings.length; i++) {
		const currentTargetString = targetStrings[i];
		const currentRating = compareTwoStrings(mainString, currentTargetString)
		ratings.push({target: currentTargetString, rating: currentRating})
		if (currentRating > ratings[bestMatchIndex].rating) {
			bestMatchIndex = i
		}
	}


	const bestMatch = ratings[bestMatchIndex]

	return { ratings, bestMatch, bestMatchIndex }
}
function areArgsValid(mainString, targetStrings) {
	if (typeof mainString !== 'string') return false
	if (!Array.isArray(targetStrings)) return false
	if (!targetStrings.length) return false
	if (targetStrings.find(s => typeof s !== 'string')) return false
	return true
}

function reqFn(str){
  throw new Error(`Cannot require "${str}": req polyfill not set.`)
}
let req = reqFn
try{
  if( window && window.require ) {
    // console.log('have window.require')
    req = window.require.bind(null)
  } else if( global && global.require ) {
    req = global.require.bind(null)
  }
} catch(e){
  // req = global.require.bind(null)

}

//this guy seemed to know what he was doing
//https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript#
let hashFromString = function(str) {
  var hash = 0, i, chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr   = str.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

// returns browser fetch if it's available, or node fetch if not
const getFetch = function(){
  if (typeof fetch !== 'undefined') return fetch
  console.warn('fetch is not available in this environment')
  return null
}

// formats form data (from html form, on onSubmit event)
function getFormData(target) {
  const {elements} = target
  let result = {}
  for (const elm of elements) {
    if (elm && elm.value) result[elm.id] = elm.value
  }
  return result
}


function DateToFormattedString(d, getTime = false) {

  var yyyy = d.getFullYear().toString();
  var mm = (d.getMonth()+1).toString(); // getMonth() is zero-based
  var dd  = d.getDate().toString();
  var tttt = `${d.getHours()}${d.getMinutes()}${d.getSeconds()}`
  if(getTime){
    return  (mm[1]?mm:"0"+mm[0]) + '-' + (dd[1]?dd:"0"+dd[0]) + '-' + yyyy + '-' + tttt;

  }else{
    return  (mm[1]?mm:"0"+mm[0]) + '-' + (dd[1]?dd:"0"+dd[0]) + '-' + yyyy;

  }
}

export {
  req,
  genId,
  jsPath,
  jVoid,
  clone,
  sleep,
  findInIterable,
  stringSimilarity,
  isIterable,
  promiseWrapper,
  hashFromString,
  getFormData,
  getFetch,
  userToFile,
  fileToUser,
  DateToFormattedString
}
